
export const Messages = {

    error : 'Please fill all the required fields with valid input',
    success: 'Success',
    failed:'Failed',
    otpSucess: 'OTP Verified Successfully',
    loginSuccess: 'Login Successful',
    saved: 'Saved',
    updated: 'Updated',
    deleted: 'Deleted',
    downloadReport: 'Complete',
    chooseDate: 'Please choose Date',
    dateValidate: 'Start Date must be less than End Date',
    noData: 'No Data Found',
    noDateSelected: 'Please select date range',
    validInput: 'Please enter valid input',
    unKnownError: 'There was an Network/ Unknown error while processing the request. Please contact the support team.',
    fileLargeError : 'The uploaded image is may be large,can you please try with another image',
    sessionExpired : 'Session has expired, please login again!',
    validateForMerchantName: 'Please enter merchant name to search',
};
